import React from 'react';
import { MapPin, Phone, User as UserIcon } from 'lucide-react';

const AddressCard = ({ address, onEdit, onDelete, onSetDefault }) => {
  const { _id, shopName, contactPerson, phone, street, city, state, postalCode, country, isDefault } = address;

  return (
    <div className="address-card-item">
      <div>
        <div className="address-card-header">
          <h4 className="address-shop-name">{shopName}</h4>
          {isDefault && <span className="default-address-badge">Default</span>}
        </div>

        <div className="address-card-body" style={{ marginTop: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <UserIcon size={14} className="text-muted" />
            <span><strong>{contactPerson}</strong></span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Phone size={14} className="text-muted" />
            <span>{phone}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginTop: '4px' }}>
            <MapPin size={14} style={{ marginTop: '3px' }} className="text-muted" />
            <span>
              {street}, {city}, {state} - {postalCode}, {country}
            </span>
          </div>
        </div>
      </div>

      <div className="address-card-actions">
        <div className="address-card-actions-left">
          <button onClick={() => onEdit(address)} className="btn-address-action">
            Edit
          </button>
          <button onClick={() => onDelete(_id)} className="btn-address-action delete">
            Delete
          </button>
        </div>
        {!isDefault && onSetDefault && (
          <button onClick={() => onSetDefault(_id)} className="btn-address-action make-default">
            Set Default
          </button>
        )}
      </div>
    </div>
  );
};

export default AddressCard;
